import Vue from "vue";
import App from "./App.vue";
import store from "./components/vuex/store.js";
import "./assets/styles/styles.scss";
import router from "./router/router";
import "material-design-icons-iconfont";

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  store,
  router,
}).$mount("#app");
